import groq from 'groq';

import { ASSET } from '../common';

export const QUOTE = groq`
  _type,
  text,
  attribution -> {
    name,
    role,
    image { ${ASSET} }
  },
  transcriptVideo {
    video {
      public_id,
      duration
    },
    timestampedTranscript[] {
      timestamp,
      text
    },
    poster { ${ASSET} }
  }
`;

export const QUOTE_BLOCK = groq`
  _type == 'quote' => @ -> {
    ${QUOTE}
  }
`;
